import {
    RequestIdWithWarning,
    replaceRequestId,
    RequestDays,
    DateVobo,
} from '../../components/utilities/Table/generalColumns/RequestIdWithWarning';
import { OfficeRequest } from '../../components/utilities/Table/generalColumns/RegionalRequest';
import { ClientIdentification } from '../../components/utilities/Table/generalColumns/ClientIdentification';
import { ExecutiveWithTooltip } from '../../components/utilities/Table/generalColumns/ExecutiveWithTooltip';
import { StatusWithTooltip } from '../../components/utilities/Table/generalColumns/StatusWithTooltip';
import { CausalRequest } from '../../components/utilities/Table/generalColumns/CausalRequest';

const commonColumns = [
    RequestIdWithWarning('gestionsolicitud.fecha_ejecutivo'),
    // {
    //     Header: 'Fecha Ejecutivo',
    //     accessor: 'gestionsolicitud.fecha_ejecutivo',
    // },
    {
        Header: 'Producto',
        accessor: 'subproducto.label',
    },
    OfficeRequest,
    ClientIdentification,
    {
        Header: 'Cliente',
        accessor: 'persona.full_name',
        typeId: 'HeaderClient',
    },
    ExecutiveWithTooltip,
];

export const requestsListStatus = [
    {
        id: 'tableBGMesaDeAprobacion',
        label: 'EN BOLSA GENERAL',
        status: 30,
        responsable: false,
        columns: (() => {
            const cols = [...commonColumns];
            cols.splice(1, 0, RequestDays('gestionsolicitud.fecha_creacion'));

            cols.splice(2, 0, DateVobo());
            return cols;
        })(),
        buttonAction: [{ name: 'takeRequest' }],
    },
    {
        id: 'tableEPMesaDeAprobacion',
        label: 'EN PROCESO',
        status: 30,
        responsable: true,
        columns: (() => {
            const cols = [...commonColumns];
            cols.splice(1, 0, RequestDays('gestionsolicitud.fecha_creacion'));
            cols.splice(2, 0, DateVobo());

            return cols;
        })(),
    },
    {
        id: 'tablePMesaDeAprobacion',
        label: 'PROCESADAS',
        status: false,
        nameColumnProcessed: [
            {
                name: 'estado_solicitud__gt',
                value: 30,
                operator: '%26',
            },
            {
                name: 'gestionsolicitud__usuario_mesa_aprobacion',
                value: 'user',
                operator: '|',
            },
            {
                name: 'gestionsolicitud__usuario_rechazo',
                value: 'user',
                operator: '|',
            },
            {
                name: 'gestionsolicitud__usuario_desistimiento',
                value: 'user',
                operator: '|',
            },
        ],
        responsable: false,
        columns: replaceRequestId(
            (() => {
                const cols = [...commonColumns];
                cols.splice(9, 0, StatusWithTooltip);
                cols.splice(10, 0, CausalRequest);
                cols.splice(2, 0, DateVobo());

                return cols;
            })()
        ),

        buttonAction: [{ name: 'resumeStatusRequest' }],
        registrationLimit: 5, // limit for registration in list credits
    },
];
